// ===========================================
// 特定の画像を読み込み終わったら処理を実行する関数
// ===========================================
export const setLoadAllCallback = (elems, callback) => {
  let count = 0;
  for (let i = 0; i < elems.length; ++i) {
    elems[i].onload = function() {
      ++count;
      if (count == elems.length) {
        // All elements have been loaded.
        callback(elems);
      }
    };
  }
}